import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type NotificationToastType = 'success' | 'warning' | 'error';

export interface NotificationToastAction {
  label: string;
  callback: () => void;
}

export interface NotificationToastMessage {
  text: string;
  type: NotificationToastType;
  action?: NotificationToastAction;
  durationMs?: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationServiceHM {
  private toastSubject = new Subject<NotificationToastMessage>();

  getToastObservable() {
    return this.toastSubject.asObservable();
  }

  showToast(
    text: string,
    type: NotificationToastType,
    options?: { action?: NotificationToastAction; durationMs?: number }
  ) {
    this.toastSubject.next({
      text,
      type,
      action: options?.action,
      durationMs: options?.durationMs
    });
  }
}
